import DropDown, { ContextMenuItem } from "@/src/components/ui-kit/drop-down";
import { useTheme } from "@/src/styles/theme-provider";
import type { Category } from "@/src/models/category.model";
import { Edit2, Trash } from "iconsax-react-nativejs";
import React from "react";
import { useTranslation } from "react-i18next";
import { Text, View } from "react-native";

type CategoryRowProps = Readonly<{
  category: Category;
  isLast?: boolean;
  onEdit: (category: Category) => void;
  onDelete: (category: Category) => void;
}>;

const CategoryRow = ({
  category,
  isLast,
  onEdit,
  onDelete,
}: CategoryRowProps) => {
  const { t } = useTranslation();
  const { themeVars } = useTheme();

  const menuItems: ContextMenuItem[] = [
    {
      label: t("BTN_EDIT"),
      onPress: () => onEdit(category),
      rightIcon: (
        <Edit2 size={16} color={themeVars["--color-ash-1"] as string} />
      ),
    },
    {
      label: t("BTN_DELETE"),
      onPress: () => onDelete(category),
      destructive: true,
      rightIcon: (
        <Trash size={16} color={themeVars["--color-crimson-default"] as string} />
      ),
    },
  ];

  return (
    <View
      className={`flex-row items-center py-3.5 ${
        isLast ? "" : "border-b border-ash-3"
      }`}
    >
      <View className="flex-1">
        <Text className="text-sm font-medium text-slate">
          {category?.categoryName}
        </Text>
      </View>
      <View className="flex-[0.4]">
        <Text className="text-sm text-slate">{category?.Tags?.join(", ")}</Text>
      </View>
      <View className="w-10 items-center">
        <DropDown
          items={menuItems}
          iconColor={themeVars["--color-ash-1"] as string}
          iconSize={20}
          menuWidth={160}
          highlightClass="bg-primary-2"
          highlightTextClass="text-primary"
        />
      </View>
    </View>
  );
};

export default CategoryRow;
